var _path, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcoSidebarPersona(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 13.7322C13.6167 13.7215 15.286 14.0527 16.7578 14.7166C18.2346 15.3827 19.2499 16.2783 19.25 17.6902V18.2498C19.25 18.802 18.8023 19.2498 18.25 19.2498H5.75C5.19772 19.2498 4.75 18.802 4.75 18.2498V17.6902C4.75012 16.2783 5.76538 15.3827 7.24219 14.7166C8.71396 14.0527 10.3833 13.7215 12 13.7322Z",
    stroke: "#0D0E11",
    strokeOpacity: 0.29,
    strokeWidth: 1.5
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 8,
    r: 3.25,
    stroke: "#0D0E11",
    strokeOpacity: 0.29,
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoSidebarPersona);
export default __webpack_public_path__ + "static/media/ico_sidebar_persona.7120b49969138c5e22a16a95fe07fda3.svg";
export { ForwardRef as ReactComponent };